// frontend/src/store/slices/searchSlice.ts

import { create } from 'zustand'

interface SearchState {
  query: string
  filters: any
  results: any[]
  isLoading: boolean
  total: number
  page: number
  size: number

  // Actions
  setQuery: (query: string) => void
  setFilters: (filters: any) => void
  setResults: (results: any[]) => void
  setLoading: (isLoading: boolean) => void
  setTotal: (total: number) => void
  setPage: (page: number) => void
  reset: () => void
}

export const useSearchStore = create<SearchState>((set) => ({
  query: '',
  filters: {},
  results: [],
  isLoading: false,
  total: 0,
  page: 1,
  size: 20,

  setQuery: (query) => set({ query }),
  setFilters: (filters) => set({ filters }),
  setResults: (results) => set({ results }),
  setLoading: (isLoading) => set({ isLoading }),
  setTotal: (total) => set({ total }),
  setPage: (page) => set({ page }),
  reset: () => set({
    query: '',
    filters: {},
    results: [],
    isLoading: false,
    total: 0,
    page: 1
  })
}))